var _defs, _g, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMBgCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.65 177.16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "@keyframes flash-ani{0%{opacity:.4}to{opacity:1}}.m_bg_circle_svg__cls-1{fill:#4377ff}.m_bg_circle_svg__cls-2{fill:#8faeff}.m_bg_circle_svg__cls-3{fill:#aec4ff}.m_bg_circle_svg__ellipseGroup01 path,.m_bg_circle_svg__ellipseGroup02 path,.m_bg_circle_svg__ellipseGroup03 path{animation-name:flash-ani;animation-iteration-count:infinite;animation-direction:alternate}.m_bg_circle_svg__ellipseGroup01 path:nth-of-type(1),.m_bg_circle_svg__ellipseGroup02 path:nth-of-type(3),.m_bg_circle_svg__ellipseGroup03 path:nth-of-type(2){animation-duration:.8s}.m_bg_circle_svg__ellipseGroup01 path:nth-of-type(2),.m_bg_circle_svg__ellipseGroup02 path:nth-of-type(1),.m_bg_circle_svg__ellipseGroup03 path:nth-of-type(3){animation-duration:1.2s}.m_bg_circle_svg__ellipseGroup01 path:nth-of-type(3),.m_bg_circle_svg__ellipseGroup02 path:nth-of-type(2),.m_bg_circle_svg__ellipseGroup03 path:nth-of-type(1){animation-duration:1.6s}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "m_bg_circle_svg__ellipseGroup01"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-1",
    d: "M47.49 26.34c.41 0 .73-.22.73-.47s-.32-.48-.73-.48-.73.22-.73.48.33.47.73.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-2",
    d: "M49.29 25.22c.4 0 .73-.21.73-.47s-.33-.47-.73-.47-.73.21-.73.47.33.47.73.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-3",
    d: "M51.09 24.28c.41 0 .73-.21.73-.47s-.32-.47-.73-.47-.73.21-.73.47.33.47.73.47z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "m_bg_circle_svg__ellipseGroup02"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-1",
    d: "M18.61 136.81c.41 0 .73-.21.73-.47s-.32-.47-.73-.47-.72.21-.72.47.32.47.72.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-2",
    d: "M20.41 135.69c.41 0 .73-.21.73-.47s-.32-.47-.73-.47-.73.22-.73.47.32.47.73.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-3",
    d: "M22.21 134.75c.41 0 .73-.21.73-.47s-.32-.47-.73-.47-.72.21-.72.47.32.47.72.47z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "m_bg_circle_svg__ellipseGroup01"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-1",
    d: "M8.73 103.2c.35 0 .62-.24.6-.44s-.33-.35-.68-.31-.62.23-.6.44.33.36.68.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-2",
    d: "M10.3 104.08c.35 0 .62-.23.6-.44s-.32-.34-.68-.31-.61.24-.59.45.37.34.67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-3",
    d: "M11.91 105c.35 0 .62-.23.6-.44s-.33-.35-.68-.31-.62.23-.6.44.33.31.68.31z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "m_bg_circle_svg__ellipseGroup03"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-1",
    d: "M89.55 56.71c.35 0 .62-.23.6-.44s-.33-.35-.68-.31-.62.24-.6.44.33.35.68.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-2",
    d: "M91.13 57.58c.35 0 .62-.23.59-.44s-.32-.35-.67-.31-.62.23-.6.44.33.35.68.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-3",
    d: "M92.73 58.47c.35 0 .62-.23.6-.44s-.33-.35-.68-.31-.62.24-.6.44.33.35.68.31z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "m_bg_circle_svg__ellipseGroup02"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-1",
    d: "M84.1 144.71c.41 0 .73-.21.73-.47s-.32-.47-.73-.47-.73.22-.73.47.33.47.73.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-2",
    d: "M85.9 143.6c.41 0 .73-.21.73-.47s-.32-.47-.73-.47-.73.21-.73.47.33.47.73.47z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m_bg_circle_svg__cls-3",
    d: "M87.7 142.66c.41 0 .73-.21.73-.47s-.32-.47-.73-.47-.73.21-.73.47.33.47.73.47z"
  }))));
}

export default SvgMBgCircle;